export const initialState = {
  products: [],
};
